import { createSelector } from 'reselect';

const selectTicket = (state) => state.ticket;

const selectTicketList = createSelector(selectTicket, (ticket) => ticket?.list);

const selectCreatedTicket = createSelector(
	selectTicket,
	(ticket) => ticket?.created
);

const selectIndexedTicket = createSelector(
	selectTicket,
	(ticket) => ticket?.indexed
);

const selectTicketComments = createSelector(
	selectTicket,
	(ticket) => ticket?.comments
);

const selectTicketLogs = createSelector(selectTicket, (ticket) => ticket?.logs);

const selectSupportProblem = createSelector(
	selectTicket,
	(ticket) => ticket?.support_problem
);

const ticketSelectors = {
	selectTicket,
	selectTicketList,
	selectIndexedTicket,
	selectCreatedTicket,
	selectTicketComments,
	selectTicketLogs,
	selectSupportProblem,
};

export default ticketSelectors;
